export const ASSISTANT_VOICE_OPTIONS = [
  "Charon",
  "Aoede",
  "Fenrir",
  "Kore",
  "Orpheus",
  "Puck",
  "Rhea",
] as const;

export const DEFAULT_ASSISTANT_VOICE_NAME = ASSISTANT_VOICE_OPTIONS[0];
